import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectUserType,
  seledctAlowedpathlist,
} from '../../utility/Redux/profile';
import { hasPageAccess } from '../../utility/pageAccess';

const ManufacturingIndex = () => {
  const navigate = useNavigate();
  const list = [
    {
      name: 'Manufacturing',
      path: '/Manufacturing',
      userType: 'MANAGER,ADMIN ,MANUFACTURING,USER',
      onclick: () => {
        navigate('/Manufacturing');
      },
    },
    {
      name: 'Manufacturing Summary',
      path: '/Manufacturing_Summary',
      userType: 'MANAGER,ADMIN ,MANUFACTURING,USER',
      onclick: () => {
        navigate('/Manufacturing_Summary');
      },
    },
    {
      name: 'Order Booking',
      path: '/order_booking',
      userType: 'MANAGER,STORE,USER',
      onclick: () => {
        navigate('/order_booking');
      },
    },
    {
      name: 'Mfg Balance Report',
      path: '/Mfg_balance_report',
      userType: 'MANAGER,STORE,USER',
      onclick: () => {
        navigate('/Mfg_balance_report');
      },
    },
    {
      name: 'Order Summary ',
      path: '/Order_summary',
      userType: 'MANAGER,STORE,USER',
      onclick: () => {
        navigate('/Order_summary');
      },
    },
  ];

  const userType = useSelector(selectUserType);
  const allowedPages = useSelector(seledctAlowedpathlist);
  return (
    <div className="h-full p-4 ">
      <div className="grid grid-cols-2 t:grid-cols-3 d:grid-cols-6 ll:grid-cols-7 gap-3  ">
        {list[0] &&
          list.map((e, i) => {
            if (
              e.userType.includes(userType) &&
              hasPageAccess(userType, allowedPages, e.path)
            ) {
              return (
                <Button
                  key={i}
                  onClick={() => {
                    if (e.onclick) {
                      e.onclick();
                    } else {
                      navigate(e.path);
                    }
                  }}
                  variant={'contained'}
                  style={{
                    textTransform: 'none',
                    backgroundColor: 'transparent',
                    padding: '0px',
                    borderRadius: '7px',
                    overflow: 'hidden',
                  }}
                >
                  <div className="bg-[#e9e9e5] py-5 w-full text-brown">
                    {e.name}
                  </div>
                </Button>
              );
            }
          })}
      </div>
    </div>
  );
};

export default ManufacturingIndex;
